import { useTranslation } from "react-i18next";
import Link from "next/link";

import { ArticleDetail } from "@sellernote/shared/src/api/dto/entities/common/support";

import Styled from "./index.styles";

export default function BoardPrevNextItem({
  prevData,
  nextData,
  boardHref,
  className,
}: {
  prevData: ArticleDetail | undefined;
  nextData: ArticleDetail | undefined;
  boardHref: string;
  className?: string;
}) {
  const { t } = useTranslation(["sds-v1"]);

  return (
    <Styled.container
      className={`${className ? className : ""} board-prev-next-item`}
    >
      {prevData && (
        <li>
          <Link href={`${boardHref}${prevData.groupId}`}>
            <a>
              <strong>{t("sds-v1:BoardPrevNextItem_이전글")}</strong>{" "}
              <h4>{prevData.title}</h4>
            </a>
          </Link>
        </li>
      )}

      {nextData && (
        <li>
          <Link href={`${boardHref}${nextData.groupId}`}>
            <a>
              <strong>{t("sds-v1:BoardPrevNextItem_다음글")}</strong>{" "}
              <h4>{nextData.title}</h4>
            </a>
          </Link>
        </li>
      )}
    </Styled.container>
  );
}
